import { createSignal, For, Show } from "solid-js";
import { useUserContext } from "./UserContext";
import { useI18n } from "./i18n";

export default function PromoSelector() {
  const t = useI18n();
  const [userStore, setUserStore, actions] = useUserContext();
  const [selectedPromo, setSelectedPromo] = createSignal(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (selectedPromo()) {
      actions.selectPromo(selectedPromo());
    }
  };

  return (
    <div class="container mt-4">
      <div class="card">
        <div class="card-body">
          <h5 class="card-title">{t("Welcome to the Internship Management Platform")}</h5>
          <p class="card-text">
            {t("Before you can create internship agreements, please select your class/promo:")}
          </p>
          
          <form onSubmit={handleSubmit}>
            <div class="mb-3">
              <label for="promoSelect" class="form-label">{t("Select your class:")}:</label>
              <select 
                id="promoSelect" 
                class="form-select" 
                value={selectedPromo() || ""}
                onChange={(e) => setSelectedPromo(e.target.value)}
                required
              >
                <option value="" disabled>{t("Choose a class")}</option>
                <For each={Object.values(userStore.promos_by_id)}>
                  {(promo) => (
                    <option value={promo.id}>{promo.name}</option>
                  )}
                </For>
              </select>
            </div>
            <button type="submit" class="btn btn-primary">
              {t("Confirm Selection")}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}